<template>
  <div class="border border-neutral-200 rounded-lg hover:shadow-md h-full">
    <div class="flex flex-col h-full">
      <UiMaskedLink
        role="link"
        tabindex="0"
        :aria-label="review?.object.hausname"
        :href="review?.object?.url"
        :new-tab="true"
      >
        <div class="flex flex-row p-4 gap-4 min-h-[130px]">
          <div class="bg-white rounded-lg overflow-hidden h-[110px] w-[110px]">
            <img
              :src="review?.object.bilder_neu[0]"
              class="object-cover object-center h-[110px] w-[110px]"
              :alt="review?.object?.hausname"
              height="110"
              width="110"
            >
          </div>
          <div class="flex flex-col gap-y-1">
            <div class="text-sm text-gray-600">
              <UiIcon src="/svg/icons/location.svg" height="12px" width="12px" class="fill-neutral-600 -mt-px inline-block" />
              {{ review?.object.region }}
              <span class="mx-0.5">·</span>
              {{ review?.object.ortsname }}
            </div>
            <UiHeadline design="h4" type="h3" class="truncate-multiline">
              {{ truncateText(review?.object.hausname, 54) }}
            </UiHeadline>
            <div class="text-sm text-gray-600">
              {{ review?.object.wohnflaeche }}m²
              <span class="mx-0.5">·</span>
              {{ review?.object.personen }}
              <UiLanguagePlaceholder domain="SharedObjectCard" name="guests" />
              <span v-if="review?.object.schlafzimmer > 0" class="block">
                {{ review?.object.schlafzimmer }} <UiLanguagePlaceholder domain="SharedObjectCard" name="bedroom" />
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-row items-end justify-between gap-2 px-4 pb-3">
          <div class="-mb-0.5">
            <SharedStars design="compact_card" :rating-text="true" :number-of-reviews="review?.object.bewertung_count" :rating="review?.object.bewertung_durchschnitt" />
          </div>
          <div class="text-right">
            <span class="text-sm text-gray-600">
              <UiLanguagePlaceholder domain="SharedObjectCard" name="from" />
              <span class="font-semibold text-neutral-900 text-xl ml-0.5">{{ usePrices().totalPrice(review?.object.preis_min) }}</span>
            </span>
            <span class="text-sm text-gray-600">
              <UiLanguagePlaceholder domain="SharedObjectCard" name="night" />
            </span>
          </div>
        </div>
      </UiMaskedLink>
      <hr class="border-t border-neutral-200 mx-4">
      <div class="flex flex-col px-4 pt-4 pb-6 h-full">
        <div class="flex flex-col grow">
          <p class="grow">
            „{{ truncateText(review?.text , 140) }}"
          </p>
          <div v-if="review?.text.length >= 140" class="mt-4 underline" @click="showModal = true">
            <span class="cursor-pointer">
              <UiLanguagePlaceholder domain="RuesHeadlineLinkCollection" name="show_more" />
            </span>
          </div>
        </div>
        <div class="flex items-center mt-7">
          <UiIcon src="/svg/icons/verifiziert-haken.svg" width="18" height="18" class="fill-green-900 inline-block" />
          <span class="ml-1 text-sm text-green-900">
            <UiLanguagePlaceholder domain="SharedObjectCard" name="verify_partner" />
          </span>
        </div>
      </div>
      <UiModal
        :modal-id="modalId"
        :open="showModal"
        @hidden="showModal = false"
      >
        <template #default>
          <p class="text-left">
            „{{ review?.text }}"
          </p>
          <div class="flex items-center mt-7">
            <UiIcon src="/svg/icons/verifiziert-haken.svg" width="18" height="18" class="fill-green-500 inline-block" />
            <span class="ml-1 text-sm text-green-500">
              <UiLanguagePlaceholder domain="SharedObjectCard" name="verify_partner" />
            </span>
          </div>
        </template>
      </UiModal>
    </div>
  </div>
</template>
<script setup lang="ts">
interface Review {
  text: string
  object: {
    hausname: string
    bilder_neu: string[]
    url: string
    region: string
    ortsname: string
    wohnflaeche: number
    personen: number
    schlafzimmer: number
    bewertung_count: number
    bewertung_durchschnitt: number
    preis_min: number
  }
}

defineProps<{ review: Review }>()

const showModal = ref(false)

const modalId = useComponentId('modal-customer-reviews')

const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text
  }
  return text.substring(0, maxLength) + '...'
}
</script>
<style scoped>
.truncate-multiline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.line-clamp-2 {
  -webkit-line-clamp: 2;
}
</style>
